module.exports = __webpack_public_path__ + "components/MapControl/svg/Inny obiekt sportu i wypoczynku.svg?867a88b0";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Inny obiekt sportu i wypoczynku.svg
// module id = 1937
// module chunks = 0